import MuiSearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';

import useFormatMessage from '@/hooks/useFormatMessage';

import { SearchButton as SearchButtonBase } from './SearchButton.style';

function SearchButton({ onSearchOpen }) {
  const formatMessage = useFormatMessage();

  return (
    <>
      <IconButton
        data-test-subject="search-button-icon"
        sx={{ display: { xs: 'flex', md: 'none' } }}
        aria-label="search"
        onClick={onSearchOpen}>
        <MuiSearchIcon color="primary" />
      </IconButton>
      <SearchButtonBase
        data-test-subject="search-button"
        variant="outlined"
        startIcon={<MuiSearchIcon />}
        color="primary"
        disableRipple
        onClick={onSearchOpen}
        sx={{ display: { xs: 'none', md: 'flex' } }}
        aria-label="search">
        {formatMessage('search_button_label')}
      </SearchButtonBase>
    </>
  );
}

export default SearchButton;
